import { Model, attr, belongsTo } from '@elatonsev/js-models';
import PhotoModel from './PhotoModel';

export default class UserModel extends Model {
  full_name = attr('string');
  email = attr('string');
  phone = attr('string');
  avatar = belongsTo(PhotoModel);
}